<script setup lang="ts">
import { useCatalogDataProvider } from '~/layers/catalog/composables/catalogDataProvider'
import { useCatalogStore } from '~/layers/catalog/store/catalog'
import { useCatalogGridStore } from '~/layers/catalog/store/catalogGrid'

const store = useCatalogStore()
const gridStore = useCatalogGridStore()
const { pending, pendingMore, getPageHref } = useCatalogDataProvider()

const setPage = (page: number) => {
  if (page === store.page) {
    return
  }

  store.setPage(page)
  store.setInitialPage(page)
  useCatalogEventBus().emit('page:updated')
}

const onClickMore = () => {
  const newPage = store.page + 1
  store.setPage(newPage)
  useCatalogEventBus().emit('page:more')
}

const onIntersectionMore = () => {
  if (
    store.page > 3 ||
    gridStore.navigation.isLastPage ||
    pending.value ||
    pendingMore.value
  ) {
    return
  }

  onClickMore()
}
</script>

<template>
  <UPagination
    :page="gridStore.navigation.page"
    :last-page="gridStore.navigation.lastPage"
    :intersection="true"
    :get-page-href="getPageHref"
    @intersection-more="onIntersectionMore"
    @click-more="onClickMore"
    @update:page="setPage($event)"
  />
</template>
